import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../constants';

const InsuranceContract = ({
  contract,
  devices,
  deviceSpecs = {},
  insurancePlan = {},
}) => {
  return (
    <div>
      <h1>Device Protection Contract</h1>
      {contract && contract.user_profile && (
        <p className="links">
          <Link to={`/users/${contract.user_profile}/view`}>
            &larr; Back to User
          </Link>
        </p>
      )}
      <table className="table">
        <tbody>
          <tr>
            <td>Contract ID</td>
            <td>{contract.id}</td>
          </tr>
          <tr>
            <td>User Profile ID</td>
            <td>{contract.user_profile}</td>
          </tr>
          <tr>
            <td>Sprint Subscription</td>
            <td>{contract.subscription}</td>
          </tr>
          <tr>
            <td>AT&T Subscription</td>
            <td>{contract.att_subscription}</td>
          </tr>
          <tr>
            <td>Quick Subscription</td>
            <td>{contract.quick_subscription}</td>
          </tr>
          <tr>
            <td>Tracfone Subscription</td>
            <td>{contract.tracfone_subscription}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>{contract.status}</td>
          </tr>
          <tr>
            <td>Sprint Active</td>
            <td>{contract.sprint_active}</td>
          </tr>
          <tr>
            <td>AT&T Active</td>
            <td>{contract.att_active}</td>
          </tr>
          <tr>
            <td>Tracfone Active</td>
            <td>{contract.tracfone_active}</td>
          </tr>
          <tr>
            <td>Quick Active</td>
            <td>{contract.quick_active}</td>
          </tr>
          <tr>
            <td>Created At</td>
            <td>{moment(contract.created_at).format(DATE_TIME_FORMAT)}</td>
          </tr>
          <tr>
            <td>Activated At</td>
            <td>
              {contract.activated_at
                ? moment(contract.activated_at).format(DATE_TIME_FORMAT)
                : ''}
            </td>
          </tr>
          <tr>
            <td>Last Updated</td>
            {contract.updated_at ? (
              <td>{moment(contract.updated_at).format(DATE_TIME_FORMAT)}</td>
            ) : (
              <td></td>
            )}
          </tr>
          <tr>
            <td>Expiry Type</td>
            <td>{contract.expiry_type}</td>
          </tr>
          <tr>
            <td>Expiration Date</td>
            {contract.expiry_date ? (
              <td>{moment(contract.expiry_date).format(DATE_TIME_FORMAT)}</td>
            ) : (
              <td></td>
            )}
          </tr>
          <tr>
            <td>Devices</td>
            <td>
              {devices &&
                devices.map((device) => {
                  return (
                    <span key={device.id}>
                      <Link to={`/device-protection/devices/${device.id}/view`}>
                        ID: {device.id} SKU: {device.device_specs}
                      </Link>
                      <br />
                    </span>
                  );
                })}
            </td>
          </tr>
          <tr>
            <td>Device ID</td>
            <td>{contract.device_id}</td>
          </tr>
          <tr>
            <td>Color</td>
            <td>{deviceSpecs.color}</td>
          </tr>
          <tr>
            <td>Capacity</td>
            <td>{deviceSpecs.capacity}</td>
          </tr>
          <tr>
            <td>Model</td>
            <td>{deviceSpecs.name}</td>
          </tr>
          <tr>
            <td>Brand</td>
            <td>{deviceSpecs.brand}</td>
          </tr>
          <tr>
            <td>Plan Name</td>
            <td>{insurancePlan.name}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default InsuranceContract;
